import { createSelector } from 'reselect'

import { MODULE_LIST } from 'src/constants'

export const patientSelector = (state) => state.patient
export const patientProgramSelector = createSelector(
  patientSelector,
  (patient) => patient.program
)
export const patientProfileSelector = createSelector(
  patientSelector,
  (patient) => patient.profile
)
export const patientCoursesSelector = createSelector(
  patientSelector,
  (patient) => patient.courses
)

export const patientDemographicsSelector = createSelector(
  patientSelector,
  (patient) => patient.demographics
)

// licenses selectors
const userProfile = (state) => state.user.profile

export const pathwayEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.clinicalPathway)
      .length
)

export const medicationEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.medication).length
)

export const educationEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.education).length
)

export const gamificationEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.gamification)
      .length
)

export const measurementEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.measurement)
      .length
)

export const chatEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.chat).length
)

export const broadcastEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.broadcast).length
)

export const carePlanEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.carePlan).length
)

export const teleMedicineEnable$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.teleMedicine)
      .length
)

export const referralLicense$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.referral).length
)

export const soapLicense$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.soap).length
)

export const urgentCareLicense$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.urgentCare).length
)

export const payerLicense$ = createSelector(
  userProfile,
  ({ licenseModule = [] }) =>
    !!licenseModule.filter(({ name }) => name === MODULE_LIST.payer).length
)

export const patientPrimaryInsurance$ = createSelector(
  patientProfileSelector,
  (profile) => profile.primaryInsurance
)

export const patientPrimaryInsuranceProgramTypeUuid$ = createSelector(
  patientPrimaryInsurance$,
  (primaryInsurance = {}) =>
    primaryInsurance?.insuranceProgramType?.uuid || null
)

export const patientProviderUuid$ = createSelector(
  patientProfileSelector,
  (profile = {}) => profile?.provider?.uuid || null
)

export const patientLatestRisk$ = createSelector(
  patientProfileSelector,
  (profile = {}) => profile?.latestRisk || null
)
